import { loadJSView, loadReactView } from './loadView';

// JS Views
const orderSummary = loadJSView('orders/orderSummary');
const multiLevelOrderSummary = loadJSView('orders/multiLevelOrderSummary');
const checkoutSlider = loadJSView('orders/checkoutSlider');

// React Views
const orderCheckout = loadReactView('orderCheckout');

const orderViews = {
  orderSummary,
  multiLevelOrderSummary,
  checkoutSlider,
  
  orderCheckout,
};

export default orderViews;
